import React from 'react';
import { Box, Skeleton, Stack, Typography } from '@compass/core';
import { Alert } from '@mui/material';
import { SchoolEnrollmentDataProvider, useSchoolEnrollmentData } from '../contexts/SchoolEnrollmentDataContext';
import { SchoolEnrollmentFilterControls } from './SchoolEnrollmentFilterControls';
import { SchoolEnrollmentChart } from './SchoolEnrollmentChart';
import { DashboardCard } from '../components/DashboardCard';


const SchoolEnrollmentCardContent = () => {
    const { data, loading, error } = useSchoolEnrollmentData();

    if (loading) {
        return (
            <Stack spacing="md">
                <Skeleton variant="rounded" height={40} />
                <Skeleton variant="rounded" height={300} />
            </Stack>
        );
    }

    if (error) {
        return (
            <Alert severity="error" sx={{ m: 2 }}>
                {error}
            </Alert>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <SchoolEnrollmentChart data={data} />
        </Box>
    );
};


export const SchoolEnrollmentCard = () => {
    return (
        <DashboardCard title="Schools with Highest Enrollments">
            <SchoolEnrollmentDataProvider>
                <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <SchoolEnrollmentFilterControls />
                    
                    <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                        <SchoolEnrollmentCardContent />
                    </Box>
                </Box>
            </SchoolEnrollmentDataProvider>
        </DashboardCard>
    );
};